import { render } from "./LandscapeDesign.vue?vue&type=template&id=a37ddd58&scoped=true"
import script from "./LandscapeDesign.vue?vue&type=script&lang=js"
export * from "./LandscapeDesign.vue?vue&type=script&lang=js"

import "./LandscapeDesign.vue?vue&type=style&index=0&id=a37ddd58&scoped=true&lang=scss"

import exportComponent from "D:\\web\\OpenServer\\domains\\lembergflowers\\lembergflowers\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a37ddd58"]])

export default __exports__